export default function PageTen() {
    return (
        <div class="mt-5 ms-5 text-light">
            <div class="row">
                <div class="col-5">
                    <h5>Services</h5>
                    <p>Beijing Lepton Technology Itd.</p>
                    <p>Service 1: Music NFT</p>
                    <p>Service 2: Music Cryptocurrency</p>
                    <p>Service 3: Music Copyright Service</p>

                </div>
                <div class="col-4">
                    <h5>Contact</h5>
                    <p>Cooperation: + 01 234 56788</p>
                    <p>Consultation: + 01 234 56788</p>
                    <p>The Red ID: 4970561395</p>
                    <p>Wechat: Lepton DAO</p>
                    <p>Email: leptondao@163.com</p>

                </div>
                <div class="col-3">
                    <h5>About Us</h5>
                    <p>No.5 Yiheyuan Road, 100871</p>
                    <p>公安备案号：xxxxxxx</p>
                    <p>Fax: </p>
                    <p>Social Credit Code: </p>

                </div>

            </div>
        </div>
    )
}